module.exports = __webpack_public_path__ + "static/media/directDownloadIcon.7bf428f8.svg";